let circles_color = [];
let paths_color = [];
let paths = document.querySelectorAll('.hero-animation svg path')
let circles = document.querySelectorAll('.hero-animation svg circle');
let colors = ["#0044FF", 'white', 'transparent'];
if (paths && circles) {
    paths.forEach(path => {
        paths_color.push(path.getAttribute('fill'));
        let rand = Math.floor(Math.random() * 3);
        path.setAttribute('fill', colors[rand])
    });
    circles.forEach(circle => {
        circles_color.push(circle.getAttribute('fill'));
        let rand = Math.floor(Math.random() * 3);
        circle.setAttribute('fill', colors[rand])
    });
    let timeout = true;
    setInterval(() => {
        paths.forEach((path, index) => {
            let rand = Math.floor(Math.random() * 3);
            if (timeout) {
                path.setAttribute('fill', colors[rand])
            } else {
                if (paths_color[index] !== path.getAttribute('fill')) {
                    path.setAttribute('fill', colors[rand])
                }
            }
        });
        circles.forEach((circle, index) => {
            let rand = Math.floor(Math.random() * 3);
            if (timeout) {
                circle.setAttribute('fill', colors[rand])
            } else {
                if (circles_color[index] !== circle.getAttribute('fill')) {
                    circle.setAttribute('fill', colors[rand])
                }
            }
        });
    }, 500);
    setTimeout(() => {
        timeout = false;
    }, 5000);
}

let files = document.querySelectorAll('.entry-type-file');
if (files) {
    files.forEach(file => {
        let filecontent = document.createElement('div');
        filecontent.className = "entry-file-content";
        file.appendChild(filecontent);
        let fileinput = file.querySelector('.entry-input')
        fileinput.addEventListener('change', function () {
            if (this.files.length) {
                filecontent.innerHTML = '';
                let fileitem = document.createElement('div');
                fileitem.className = "entry-file-item";
                filecontent.appendChild(fileitem);

                let fileitemtext = document.createElement('div');
                fileitemtext.className = "entry-file-item-text";
                fileitem.innerText = this.files[0].name;
                fileitem.appendChild(fileitemtext);
                let fileitemclose = document.createElement('div');
                fileitemclose.className = "entry-file-item-close";
                fileitem.appendChild(fileitemclose);
                fileitemclose.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.66732 1.27325L8.72732 0.333252L5.00065 4.05992L1.27398 0.333252L0.333984 1.27325L4.06065 4.99992L0.333984 8.72658L1.27398 9.66658L5.00065 5.93992L8.72732 9.66658L9.66732 8.72658L5.94065 4.99992L9.66732 1.27325Z" fill="currentColor"/>
                </svg>`;
                fileitemclose.addEventListener('click', function () {
                    fileitem.remove();
                    fileinput.value = '';
                    fileinput.files = [];
                })

            }
        })
    });
}


// WEBPACK FOOTER //
// ./scripts/hero-animation.js